import {Component} from '@angular/core';
import {MatToolbar} from "@angular/material/toolbar";

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [MatToolbar]
})
export class FooterComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
